import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";

export class ProbationayDecisionTypeModel
  extends Model
  implements IModel<ProbationayDecisionTypeModel> {
  public companyGroupId: string = "";
  public assessmentPeriod: string = "";
  public title: string = "";
  public finalize: boolean = false;
  public hasDischarge: boolean = false;
  public dismissalRequestParameters: string = "";

  static create(input: any): ProbationayDecisionTypeModel {
    return ObjectMapper.deserialize<ProbationayDecisionTypeModel>(
      ProbationayDecisionTypeModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
